class ProductGridRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const fetchedGrid = temp.querySelector('.product-grid__products');

        if (fetchedGrid && fetchedGrid.innerHTML.trim().length) {
          this.innerHTML = fetchedGrid.innerHTML;
        } else {
          this.innerHTML = '';
        }
      })
      .catch((error) => {
        console.error('Failed to load product recommendations:', error);
      });
  }
}

if (!customElements.get('product-grid-recommendations')) {
  customElements.define(
    'product-grid-recommendations',
    ProductGridRecommendations
  );
}